import React, { Component } from "react";
import { connect } from "react-redux";

import { setPopup, showMessage } from "../actions/siteActions";
import Bucket from "./Bucket";

class Popup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      displayErrors: false,
      sendingState: 0,
      fetchURL: "send.php",
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(event) {
    const { site } = this.props;
    event.preventDefault();
    if (!event.target.checkValidity()) {
      this.setState({ displayErrors: true });
      return;
    }
    const data = new FormData(event.target),
      { fetchURL } = this.state;
    this.setState({ displayErrors: false, sendingState: 1 });

    data.append("type", site.popup.type);
    if (site.popup.type === "request-products") {
      data.append("products", JSON.stringify(site.bucket));
    }

    fetch(`${fetchURL}`, {
      method: "POST",
      body: data,
    })
      .then((response) => response.json())
      .then((response) => {
        this.setState({ sendingState: 2 });
       // console.log("Success:", JSON.stringify(response));
        this.props.showMessage(true, "Saadetud");
        this.form.reset();
      })
      .catch((error) => console.error("Error:", error));
    this.setState({ displayMessage: true });
  }

  closePopup = () => {
    const { site } = this.props;
    this.props.setPopup(site.popup.type, !site.popup.show);
  };

  render() {
    const { site } = this.props;
    const { displayErrors } = this.state;
    return (
      <div className="popup">
        <div className="bg" onClick={() => this.closePopup()} />
        <div className="inside">
          {" "}
          <button className="closeBtn" onClick={() => this.closePopup()}>
            &#10005;
          </button>
          {site.bucket && site.popup.type === "request-products" && (
            <React.Fragment>
              <h3>Valitud tooted</h3>
              <Bucket />
            </React.Fragment>
          )}
          <form
            onSubmit={this.handleSubmit}
            noValidate
            className={`requestForm ${displayErrors ? "displayErrors" : ""}`}
            ref={(form) => (this.form = form)}
          >
            <label data-label="Nimi">
              <input
                type="text"
                name="nimi"
                id="nimi"
                defaultValue=""
                maxLength="100"
                required
              />
            </label>

            <label data-label="Ettevõte, amet">
              <input
                type="text"
                name="amet"
                id="amet"
                defaultValue=""
                maxLength="100"
                required
              />
            </label>

            <label data-label="Email">
              <input
                type="email"
                name="epost"
                id="epost"
                defaultValue=""
                maxLength="100"
                required
              />
            </label>

            <label className="fluid" htmlFor="epostcontent" data-label="Sõnum">
              <textarea name="epostcontent" id="epostcontent" />
            </label>

            <button
              className="button button--primary"
              type="submit"
              data-action="send-request"
            >
              Saada päring
            </button>
          </form>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  site: state.site,
});

export default connect(mapStateToProps, { setPopup, showMessage })(Popup);
